interface FilterDateRangeOption {
  translationKey: string;
  value: '30_DAYS' | '90_DAYS' | '180_DAYS' | 'CUSTOM';
}

export interface FilterDateRange {
  option: FilterDateRangeOption;
  start: Date;
  end: Date;
}

export const defaultFilterDateRangeOption: FilterDateRangeOption = {
  translationKey: 'points_transaction.date_range.last_180_days',
  value: '180_DAYS',
};
